import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LeucodermaPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Leucoderma</h1>
        <section className="mb-8">
          <p>Leucoderma, also known as vitiligo, is a skin condition characterized by white patches due to loss of skin pigmentation. Our natural therapies focus on restoring skin color, preventing spread, and improving overall skin health through gentle, holistic approaches.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Autoimmune factors</li>
            <li>Genetic predisposition</li>
            <li>Stress and anxiety</li>
            <li>Environmental triggers</li>
            <li>Hormonal changes</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>White patches on skin</li>
            <li>Loss of skin color</li>
            <li>Premature graying of hair</li>
            <li>Changes in eye color</li>
            <li>Itching in affected areas</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use skin-repigmenting herbs, stress management techniques, and lifestyle modifications to naturally treat leucoderma. Our approach focuses on restoring skin color, preventing spread, and improving overall skin health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural skin repigmentation</li>
            <li>Prevents spread of patches</li>
            <li>No harsh side effects</li>
            <li>Long-term results</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Protect skin from sun exposure</li>
            <li>Manage stress levels</li>
            <li>Maintain a balanced diet</li>
            <li>Regular exercise</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment cure leucoderma?</strong>
            <p>A: While complete cure may not be possible, our treatments can effectively manage symptoms and improve skin appearance.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for all skin types?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all skin types.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see results?</strong>
            <p>A: Many patients notice improvement within a few months of starting treatment.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Restore your skin's natural color—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default LeucodermaPage; 